new Vue({
    el:'.summer26',
    data(){
        return {
            loadFlag:false,
            isLottery:true,
            sendFlag:false,
            submitFlag:false,
            popup:false,
            gameMask:false,
            gamePopup:false,
            recordPopup:false,
            addressPopup:false,
            prizePopup:false,
            sharePopup:false,
            rulePopup:false,
            loginPopup:false,
            isSend:false,
            isLogin:false,
            sendText:'Send code',
            findText:'',
            user:{
                name:'',
                email:'',
                code:'',
                country:'Country',
                invite_code:'',
                points:0,
                is_win:false,
                invite_num:0
            },
            address:{
                state:'',
                city:'',
                street:'',
                postal:'',
                phone:''
            },
            popup1:false,
            select_flag1:0,
            countryArr:[],
            pointsHistory:[],
            recordNav:['Chance Record','Winning Record'], 
            recordIndex:0,
            prizeName:localStorage.getItem('OXVA_summer_prize') || '',
            className:'',
            prizeAll:{
                XLIM_GO_LITE:false,
                XLIM_PRO_3:false,
                OXVA_Summer_Merch:false,
                OXVA_NEXLIM_2_2_MINI_Gift_Box:false,
                Lucky_Try:false,
            },
            winnerArr:[],
            gamePage:false,
            badgeImg:[
                'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/1_6755c331-c634-4287-aa79-6cf2606d72ba.avif?v=1781667245',
                'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/2_1aed4f83-86ec-4ea3-bb6b-49cba02b63ee.avif?v=1781667245',
                'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/3_d2062ddc-b04d-4b69-8508-25613d9f2b55.avif?v=1781667244',
                'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/4_37b0fe5b-76ca-4dc2-bc84-141ed7adcc1f.avif?v=1781667244',
            ],
            badgeIndex:0,
            goalNum:0
        }
    },
    methods:{
        // 功能类-------------------------------------------------
        async submitAddress(){
            if(!this.address.state || !this.address.city || !this.address.street || !this.address.postal || !this.address.phone){
                return showMessage('Please fill in the information completely','error');
            } 

            //showMessage('Submitting, please wait...','success')
            //避免重复提交 
            if(this.submitFlag) return;
            this.submitFlag = true
            this.address.name = this.user.name
            this.address.email = this.user.email
            this.address.country = this.user.country

            var params=new URLSearchParams();
            params.append('info',JSON.stringify(this.address));
            let res = await axios.post('https://service.oxvatech.cn/summer/submitAddress',params, {
                headers: { Authorization: `${this.user.token}`}
            });
            if(res.data.status == 200){
                showMessage('Submission successful, preparing for shipment.','success')
            }else{
                let errorMessages = {
                    202: 'Ops, No winning information found.',
                    500:' Server error, please contact customer service',
                };
                showMessage(errorMessages[res.data.status] || 'Unknown error', 'error');
            }
            this.popup = this.addressPopup = this.submitFlag = false
        },
        async lottery(){
            if(!this.checkLogin()) return;
            if(!this.isLottery) return;
            if(this.user.chance<1){
                showMessage('Oops! No Spins Left.','error')
                return;
            }

            // 开始抽奖
            this.isLottery = false
            let res = await axios.post('https://service.oxvatech.cn/summer/lottery',{},{
                headers: { Authorization: `${this.user.token}`}
            });
            if(res.status == 200){
                var status = res.data.status
                if(status==200){
                    //中奖
                    this.prizeName = res.data.data
                    localStorage.setItem('OXVA_summer_prize', this.prizeName) //存储中奖信息;
                    //&、空格和短横线转为下划线
                    var str = res.data.data.replace(/[ &-]/g, '_').replace(/_+/g, '_');
                    this.prizeAll[str] = true
                    this.Spin()
                    this.getInfo()
                    this.getData() //更新中奖者
                }else if(status==202){
                    //未中奖
                    this.prizeAll.Lucky_Try = true
                    this.user.chance -= 1
                    this.Spin()
                }else{
                    this.isLottery = true
                    let errorMessages = {
                        201: 'Oops! No Spins Left.',
                        500:' Server error, please contact customer service',
                    };
                    showMessage(errorMessages[status] || 'Unknown error', 'error');
                }
            }else{
                showMessage('Server Error','error')
            }
        },
        async getChance(type){
            if(type=='Upload'){
                if(this.user.is_upload==1) return;
            }else if(type=='Share'){
                if(this.user.is_share==1) return;
            }
            let params=new URLSearchParams();
            params.append('action',type);
            let res = await axios.post('https://service.oxvatech.cn/summer/getChance',params,{
                headers: { Authorization: `${this.user.token}`}
            });
            if(res.data.status==200){
                this.getInfo() //更新积分记录
                showMessage("You've earned 1 extra spin!",'success')
            }
        },
        async sendEmail(){
            if(this.user.email == ''){
                showMessage('Please enter your email','error')
                return;
            }
            // 邮箱正则表达式
            var emailReg = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
            if(!emailReg.test(this.user.email)){
                showMessage('Email format error','error')
                return;
            }
            if(this.sendFlag){
                showMessage('Sent, please try again in one minute.','success')
                setTimeout(() => {
                    this.sendFlag = false
                    this.sendText = 'Send code'
                }, 1000*60);
                return;
            }
            this.sendText = 'Has sent'
            this.sendFlag = true
            var params=new URLSearchParams();
            params.append('info',JSON.stringify(this.user));
            let res = await axios.post('https://service.oxvatech.cn/summer/sendEmail',params);
            if(res.data.status == 200){
                this.isSend = true
                showMessage('Email has been sent, please check.','success')
            }else{
                showMessage('Server error, please contact customer service','error')
            }
        },
        async loginActivity(){
            if(!this.isSend){
                showMessage('Please send the email verification code first','error')
                return;
            }
            if(!this.user.name || !this.user.email || this.user.country == 'Country' || !this.user.code){
                showMessage('Please fill in the information completely','error')
                return;
            }
            // 邮箱正则表达式
            var emailReg = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
            if(!emailReg.test(this.user.email)){
                showMessage('Email format error','error')
                return;
            }
            //避免重复提交
            if(this.submitFlag) return;
            this.submitFlag = true
            var params=new URLSearchParams();
            params.append('info',JSON.stringify(this.user));
            let res = await axios.post('https://service.oxvatech.cn/summer/loginActivity',params);
            if(res.data.status == 200){
                this.setCookie('_OXVA_Cheers_to_good_times_',res.data.data,90)
                this.user.token = res.data.data
                showMessage('Good luck! ','success')
                this.popup = this.loginPopup = false
                this.getInfo()
            }else{
                let errorMessages = {
                    201: 'Email verification code error',
                    202: 'Username already exists',
                    500:' Server error, please contact customer service',
                };
                showMessage(errorMessages[res.data.status] || 'Unknown error', 'error');
            }
            this.submitFlag = false
        },
        async getInfo(){
            let res = await axios.post('https://service.oxvatech.cn/summer/getInfo', {}, {
                headers: { Authorization: `${this.user.token}`}
            });
            if(res.data.status == 200){
                if(res.data.data.arr1.length>0){
                    this.isLogin = true
                    this.user = res.data.data.arr1[0]
                   
                    const winner = this.winnerArr.find(item => item.name == this.user.name) || {};
                    this.prizeName = winner.prize || '';
                    this.address.state = winner.state || '';

                    // if(this.user.name == ''){}

                    //总积分记录
                    this.pointsHistory = res.data.data.arr2
                    
                }else{
                    this.isLogin = false
                }
            }else{
                showMessage('server error','error')
            }
        },
        async getData(){
            let res = await axios.get('https://service.oxvatech.cn/summer/getData')
            if(res.status == 200){
                this.winnerArr = res.data.data
                
                const winner = this.winnerArr.find(item => item.name == this.user.name) || {};
                this.prizeName = winner.prize || '';
                this.address.state = winner.state || '';
            }
        },
        async getCountry(){
            let res = await axios.get('https://service.oxvatech.cn/public/getAllCountry')
            if(res.status == 200){
                this.countryArr = res.data.data
            }
        },
        async saveCanvas() {
            if (this.submitFlag) return;
            showMessage('Downloading, please wait. . .','success')
            this.submitFlag = true;
            
            const canvas = await html2canvas(this.$refs.container, {
                backgroundColor: null,
                useCORS: true,
                allowTaint: false
            })

            const link = document.createElement("a");
            link.download ="OXVA_Good_Times_Shot.png";
            link.href = canvas.toDataURL("image/png");
            link.click();
            this.submitFlag = false;
        },
        async scoreLog(goalCount,num){
            let params=new URLSearchParams();
            params.append('info',JSON.stringify({points:goalCount,num:num}));
            let res = await axios.post('https://service.oxvatech.cn/summer/step',params,{
                headers: { Authorization: `${this.user.token}`}
            });
            if(res.data.status==500){
                showMessage("Server error, please contact customer service",'error')
            }
        },
        async startGame(){
            if(this.user.game_chance>0){
                let res = await axios.post('https://service.oxvatech.cn/summer/start',{},{
                    headers: { Authorization: `${this.user.token}`}
                });
                if(res.data.status==200){
                    this.user.game_chance -= 1
                }else{
                    showMessage("There's no chance, go share it now",'error')
                }
            }else{
                showMessage("There's no chance, go share it now",'error')
            }
        },
        // 控件类-------------------------------------------------
        playGame(){
            if(!this.checkLogin()) return;
            if(this.user.game_chance>0){
                this.gamePage = true
                setTimeout(() => {
                    this.initGame()
                }, 100);
            }else{
                return showMessage("Oops! You've reached your daily limit.",'error')
            } 
        },
        endGame(){
            // 更新数据
            this.getInfo()
        },
        showPopup(type){
            if(!this.checkLogin()) return;
            this.popup = this[type] = true;
        },
        checkLogin(){
            if(!this.isLogin){
                this.popup = this.loginPopup = true;
                return false;
            }
            return true;
            // showMessage('The event has ended, thank you for your participation','success');
            // return false
        },
        endTips(){
            showMessage('The event has ended, thank you for your participation.','success')
        },
        emailUpdate(){
            if(this.isSend){
                this.isSend = false
                this.sendFlag = false
                this.sendText = 'Send code'
            }
        },
        // 工具类-------------------------------------------------
        formatISOToDateTime(isoString) {
            var date = new Date(isoString);
          
            // 转为北京时间（+8小时）
            date.setHours(date.getHours());
          
            var pad = (n) => n.toString().padStart(2, '0');
            var year = date.getFullYear();
            var month = pad(date.getMonth() + 1);
            var day = pad(date.getDate());
            var hours = pad(date.getHours());
            var minutes = pad(date.getMinutes());
            var seconds = pad(date.getSeconds());
          
            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        },
        copyCode(text){
            // 复制指定文案到剪贴板
            navigator.clipboard.writeText(text).then(() => {
                showMessage('Copied successfully','success')
            }).catch(err => {
                showMessage('Copied failed','error')
            });
        },
        QuickFind(){
            var countryList = this.$refs.countryList; // 获取 .country_option 元素
            // 找到第一个以输入字母开头的国家元素
            var targetCountry = Array.from(countryList.children).find((country) =>
                country.textContent.trim().toLowerCase().startsWith(this.findText.toLowerCase())
            );

            if (targetCountry) {
                // 滚动到目标国家
                targetCountry.scrollIntoView({ block: 'start' });
            }
        },
        Spin(){
            Object.keys(this.prizeAll).forEach((key)=>{
                if(this.prizeAll[key]){
                    //指向哪个奖品停止
                    this.className = key
                }
            })
            setTimeout(()=>{
                //显示奖品
                this.popup = this.prizePopup = true
            },8300)

            setTimeout(() => {
                //恢复转盘
                this.className = ''
                //可再次抽奖
                this.isLottery=true
            }, 8600);
        },
        // cookie
        setCookie(name,value,day){
            var d = new Date();
            d.setTime(d.getTime() + (day * 24 * 60 * 60 * 1000));
            var expires = "expires=" + d.toUTCString();
            document.cookie = name + "=" + value + ";" + expires + ";path=/";
        },
        getCookie(name){
            var name = name + "=";
            var decodedCookie = decodeURIComponent(document.cookie);
            var cookieArray = decodedCookie.split(';');
            for(let i = 0; i < cookieArray.length; i++) {
                let cookie = cookieArray[i];
                while (cookie.charAt(0) == ' ') {
                cookie = cookie.substring(1);
                }
                if (cookie.indexOf(name) == 0) {
                return cookie.substring(name.length, cookie.length);
                }
            }
            return "";
        },
        initGame(){
            var that = this
            // 使用 jQuery 获取页面元素；Canvas 实例本身仍需取出原生 DOM 才能拿到 2D 上下文
            const $canvas = $('#game');
            const canvas = $canvas[0];
            const ctx = canvas.getContext('2d');

            const ballImg = new Image();
            ballImg.src = 'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/5c1c18adb65c7850c0e95c123d529df6_19d62eb5-4051-4d3d-a723-67bdfd418c82.png?v=1781515518';

            const grassImg = new Image();
            grassImg.src = 'https://cdn.shopify.com/s/files/1/0502/8033/3505/files/d77e4fd27e15f43c421b61c1acfb90ae.avif?v=1781513855';
            
            // HUD / 文案 / 弹层 / 按钮：统一使用 jQuery 对象，便于 text() / addClass() / on() 等操作
            const $scoreValue = $('#scoreValue');
            const $shotsValue = $('#shotsValue');
            const $bestValue = $('#bestValue');
            const $timerValue = $('#timerValue');
            const $tip = $('#tip');
            
            const $startOverlay = $('#startOverlay');
            const $startBtn = $('#startBtn');
            const $restartBtn = $('#restartBtn');
            const $endTitle = $('#endTitle');
            const $endText = $('#endText');
            
            let dpr = Math.max(1, Math.min(2, window.devicePixelRatio || 1));
            let W = 0;
            let H = 0;
            
            let finishGame;
            let resolveShot;
            
            // 游戏全局状态：分数、回合、倒计时、连击、结果文案等
            const state = {
                running: false,
                score: 0,
                shotsLeft: 7,
                bestScore: that.user.points,
                dragging: false,
                aimStart: null,
                aimCurrent: null,
                goalFlash: 0,
                particles: [],
                keeperDir: 1,
                lastTime: 0,
                combo: 0,
                level: 1,
                wind: 0,
                roundIndex: 0,
                targetDir: 1,
                resultText: '',
                resultTimer: 0,
                shotTimeLimit: 15,
                shotClock: 15,
                shotResolved: false,
                shotTimerStarted: false,
                goalCount: 0,
            };
            
            // 足球对象：控制位置、半径、飞行状态、目标点、力度等
            const ball = {
                x: 0, y: 0, r: 18,
                shadowScale: 1,
                active: false,
                flying: false,
                startX: 0, startY: 0,
                targetX: 0, targetY: 0,
                lineCrossX: 0,
                peakY: 0,
                t: 0,
                speed: 1.05,
                scored: false,
                power: 0,
                goalConfirmed: false,
                rotation: 0
            };
            
            // 球门对象：控制位置、尺寸、球网密度，以及判定进球的“球门线”
            const goal = {
                x: 0, y: 0, w: 0, h: 0,
                netCols: 10, netRows: 5,
                lineY: 0,
            };
            
            // 守门员对象：控制位置、体积、移动速度、扑救偏移
            const keeper = {
                x: 0, y: 0, w: 90, h: 40,
                speed: 220,
                dive: 0,
            };
            
            const targetZone = {
                x: 0, y: 0, w: 46, h: 34,
            };
            
            // 重新计算画布尺寸、球门位置、守门员位置等；
            // 注意：绘图仍使用原生 Canvas API，jQuery 主要负责 DOM 与事件层
            function resize() {
                dpr = Math.max(1, Math.min(2, window.devicePixelRatio || 1));
                W = window.innerWidth;
                H = window.innerHeight;
                
                canvas.width = Math.floor(W * dpr);
                canvas.height = Math.floor(H * dpr);
                canvas.style.width = W + 'px';
                canvas.style.height = H + 'px';
                ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
                
                goal.w = Math.min(W * 0.56, 340);
                goal.h = Math.min(H * 0.12, 92);
                goal.x = (W - goal.w) / 2;
                goal.y = Math.max(68, H * 0.14);
                // 进球判定线：位于球门前方一点的位置，球越过它且没碰到守门员即算进球
                goal.lineY = goal.y + goal.h + Math.max(10, H * 0.01);
                
                keeper.w = goal.w * 0.26;
                keeper.h = goal.h * 0.54;
                // 守门员站位前移一些：更靠近玩家这一侧
                keeper.y = goal.y + goal.h * 0.72;
                keeper.x = W / 2 - keeper.w / 2;
                
                targetZone.w = Math.max(40, goal.w * 0.14);
                targetZone.h = Math.max(28, goal.h * 0.34);
                
                resetBall();
                randomizeRound(true);
            }
            
            function randomizeRound(first = false) {
                state.roundIndex++;
                state.level = Math.min(5, 1 + Math.floor((7 - state.shotsLeft + (first ? 0 : 1)) / 2));
                state.wind = 0;
                // 根据当前第几球递增速度
                const shotIndex = (7 - state.shotsLeft + 1);
                keeper.speed = 180 + shotIndex * 70;
                keeper.dive = 8 + state.level * 3;
                
                const sidePadding = 10;
                const minX = goal.x + sidePadding;
                const maxX = goal.x + goal.w - targetZone.w - sidePadding;
                const minY = goal.y + 8;
                const maxY = goal.y + goal.h - targetZone.h - 6;
                
                targetZone.x = minX + Math.random() * (maxX - minX);
                targetZone.y = minY + Math.random() * (maxY - minY);
                state.targetDir = Math.random() > 0.5 ? 1 : -1;
            }
            
            function resetBall() {
                ball.r = Math.max(15, Math.min(22, W * 0.04));
                ball.x = W / 2;
                ball.y = H * 0.83;
                ball.startX = ball.x;
                ball.startY = ball.y;
                ball.active = true;
                ball.flying = false;
                ball.t = 0;
                ball.speed = 1.05;
                ball.scored = false;
                ball.power = 0;
                ball.goalConfirmed = false;
                state.dragging = false;
                state.aimStart = null;
                state.aimCurrent = null;
                state.shotClock = state.shotTimeLimit;
                state.shotResolved = false;
                state.shotTimerStarted = false;
            }
            
            // 刷新顶部 HUD 显示
            function updateHud() {
                $scoreValue.text(state.goalCount);
                var currentShot = 8 - state.shotsLeft;
                if(currentShot>7){
                    currentShot=7
                }
                $shotsValue.text(currentShot);
                $bestValue.text(state.bestScore);
                // 非逐帧场景下默认按整数显示；逐帧倒计时会在 update() 中实时覆盖
                $timerValue.text(Math.max(0, Math.ceil(state.shotClock)));
            }
            
            // 处理“超时未射门”或“本球超时失败”
            function failShotByTimeout() {
                if (!state.running || state.shotResolved) return;
                
                state.shotResolved = true;
                state.combo = 0;
                state.resultText = 'No shot taken before time expired';
                state.resultTimer = 1.5;
                state.shotsLeft -= 1;
                updateHud();
                
                // 停止当前拖拽/射门状态
                state.dragging = false;
                state.aimStart = null;
                state.aimCurrent = null;
                ball.flying = false;
                ball.active = false;
                
                createBurst(ball.x, ball.y, 10, '255,120,120');
                $tip.text('Timeout, this ball is ruled invalid.');
                
                setTimeout(() => {
                    if (state.shotsLeft <= 0) {
                        finishGame();
                    } else {
                        randomizeRound();
                        resetBall();
                        $tip.text(`Preparing Ball ${8 - state.shotsLeft} | You have 15 seconds to complete it after dragging starts`);
                        updateHud();
                    }
                }, 1500);
            }
            
            // 重置整局游戏数据
            function resetGame() {
                state.score = 0;
                state.goalCount = 0;
                state.shotsLeft = 7;
                state.goalFlash = 0;
                state.particles = [];
                state.running = true;
                state.combo = 0;
                state.resultText = '';
                state.resultTimer = 0;
                state.shotClock = state.shotTimeLimit;
                state.shotResolved = false;
                keeper.x = W / 2 - keeper.w / 2;
                state.keeperDir = Math.random() > 0.5 ? 1 : -1;
                randomizeRound(true);
                updateHud();
                resetBall();
                $tip.text('Drag to shoot. 15s limit.');
            }
            
            function beginGame() {
                // 开始游戏-----------------------------------------------------------
                that.startGame()
                $startOverlay.addClass('hidden');
                that.gameMask = that.gamePopup = false
                resetGame();
            }
            
            function createBurst(x, y, count = 12, color = '255,216,77') {
                for (let i = 0; i < count; i++) {
                    const angle = Math.random() * Math.PI * 2;
                    const speed = 70 + Math.random() * 170;
                    state.particles.push({
                        x, y,
                        vx: Math.cos(angle) * speed,
                        vy: Math.sin(angle) * speed,
                        life: 0.7 + Math.random() * 0.45,
                        age: 0,
                        size: 2 + Math.random() * 4,
                        color,
                    });
                }
            }
            
            // 根据用户拖拽位移发起射门
            function shootBall(dx, dy) {
                if (!state.running || !ball.active || ball.flying) return;
                
                // 计算拖拽总距离，过短则不触发射门
                const distance = Math.hypot(dx, dy);
                
                // 只允许“向前拖动”（向上拖动）才能射门
                // dy > 0 表示向下拖（往后），直接无效
                if (distance < 26 || dy > 0) {
                    state.dragging = false;
                    state.aimStart = null;
                    state.aimCurrent = null;
                    return;
                }
                
                // 将拖拽距离映射成 0~1 的力度值
                const maxPull = Math.min(H * 0.34, 230);
                const clamped = Math.min(distance, maxPull);
                const power = clamped / maxPull;
                
                const nx = dx / distance;
                const ny = dy / distance;
                
                // 完全按手势直线飞：
                // 以拖拽方向向前延长，和“球门线”所在高度相交的位置作为最终判定点。
                // 只要足球越过这条线，并且过程中没有碰到守门员，就算进球成功。
                const gateLineY = goal.lineY;
                
                // 用球门线来计算方向（保证判定正确）
                const scaleToGateLineY = (gateLineY - ball.y) / dy;
                const rawTargetX = ball.x + dx * scaleToGateLineY;
                
                // 记录足球穿过“不可见球门线”时的横向位置，供进球判定使用
                ball.lineCrossX = Math.min(goal.x + goal.w - 16, Math.max(goal.x + 16, rawTargetX));
                
                // 视觉落点仍然在球网内部（更真实）
                const goalCenterY = goal.y + goal.h * 0.6;
                
                ball.targetX = ball.lineCrossX;
                ball.targetY = goalCenterY;
                ball.peakY = Math.min(ball.startY - 250 * power, H * 0.24);
                ball.flying = true;
                ball.t = 0;
                ball.speed = 0.3 + power * 1.35;
                ball.scored = false;
                ball.power = power;
                
                state.dragging = false;
                state.aimStart = null;
                state.aimCurrent = null;
                $tip.text(`Shot on goal...`);
            }
            
            function getPoint(e) {
                const p = e.touches ? e.touches[0] : e;
                return { x: p.clientX, y: p.clientY };
            }
            
            function canDragAt(x, y) {
                return Math.hypot(x - ball.x, y - ball.y) <= ball.r + 18;
            }
            
            // 用户开始按下：只有点到足球时才进入拖拽瞄准状态
            function handleDown(e) {
                if (!state.running || !ball.active || ball.flying) return;
                const p = getPoint(e);
                if (canDragAt(p.x, p.y)) {
                    state.dragging = true;
                    state.aimStart = { x: ball.x, y: ball.y };
                    state.aimCurrent = { x: p.x, y: p.y };
                    
                    // 倒计时从“用户开始拖动这一球”时才开始
                    if (!state.shotTimerStarted) {
                        state.shotTimerStarted = true;
                        state.shotClock = state.shotTimeLimit;
                        $timerValue.text(Math.max(0, Math.ceil(state.shotClock)));
                    }
                    
                    $tip.text('Continue dragging upwards to shoot');
                }
            }
            
            // 用户拖拽过程中，实时更新当前指针位置
            // 这里直接禁止向下拖动：当前指针 y 不能超过起始点 y
            function handleMove(e) {
                if (!state.dragging) return;
                const p = getPoint(e);
                
                // 禁止向下拖动，只允许保持原位或向上拖
                const clampedY = Math.min(p.y, state.aimStart.y);
                
                state.aimCurrent = { x: p.x, y: clampedY };
            }
            
            // 用户松手时，根据起点与终点的位移正式射门
            function handleUp() {
                if (!state.dragging || !state.aimCurrent || !state.aimStart) return;
                const dx = state.aimCurrent.x - state.aimStart.x;
                const dy = state.aimCurrent.y - state.aimStart.y;
                shootBall(dx, dy);
            }
            
            // 每一帧更新：守门员移动、足球飞行、粒子、倒计时等
            function update(dt) {
                if (!state.running) return;
                
                // 本球倒计时：从“用户开始拖动这一球”后才开始流逝
                if (!state.shotResolved && state.shotTimerStarted) {
                    state.shotClock = Math.max(0, state.shotClock - dt);
                    // 实时刷新倒计时显示（整秒跳动）
                    $timerValue.text(Math.max(0, Math.ceil(state.shotClock)));
                    if (state.shotClock <= 0) {
                        failShotByTimeout();
                        return;
                    }
                } else {
                    // 尚未开始拖动时，固定显示完整秒数；出结果后显示剩余秒数
                    $timerValue.text(Math.max(0, Math.ceil(state.shotClock)));
                }
                
                const minX = goal.x;
                const maxX = goal.x + goal.w - keeper.w;
                
                // 守门员随机移动：方向、停顿、速度微变化都不固定
                if (Math.random() < 0.018 + state.level * 0.004) {
                    state.keeperDir = Math.random() > 0.5 ? 1 : -1;
                }
                if (Math.random() < 0.008) {
                    state.keeperDir = 0;
                }
                if (state.keeperDir === 0 && Math.random() < 0.06) {
                    state.keeperDir = Math.random() > 0.5 ? 1 : -1;
                }
                
                const keeperStep = keeper.speed * (0.8 + Math.random() * 1.2) * dt;
                keeper.x += state.keeperDir * keeperStep;
                
                if (keeper.x <= minX) {
                    keeper.x = minX;
                    state.keeperDir = Math.random() < 0.75 ? 1 : 0;
                } else if (keeper.x >= maxX) {
                    keeper.x = maxX;
                    state.keeperDir = Math.random() < 0.75 ? -1 : 0;
                }
                
                
                
                if (ball.flying) {
                    ball.rotation += dt * 12;
                    ball.t += dt * ball.speed;
                    const t = Math.min(ball.t, 1);
                    const ease = 1 - Math.pow(1 - t, 3);
                    
                    // 完全按手势直线飞：x/y 都沿起点到终点的直线插值，
                    // 不再叠加抛物线弧度，避免视觉上偏离白色虚线方向。
                    ball.x = ball.startX + (ball.targetX - ball.startX) * ease;
                    ball.y = ball.startY + (ball.targetY - ball.startY) * ease;
                    ball.shadowScale = 1 - 0.58 * ease;
                    
                    const keeperReactionBoost = state.level >= 3 ? Math.sin(t * Math.PI) * keeper.dive : 0;
                    const reactiveKeeperX = keeper.x + (ball.targetX > keeper.x + keeper.w / 2 ? keeperReactionBoost : -keeperReactionBoost);
                    
                    // 只有在“还没有越过红线确认进球”之前，守门员才有机会扑到球。
                    if (!ball.goalConfirmed) {
                        const hitX = ball.x >= reactiveKeeperX && ball.x <= reactiveKeeperX + keeper.w;
                        const hitY = ball.y >= keeper.y - 16 && ball.y <= keeper.y + keeper.h + 12;
                        if (hitX && hitY) {
                            ball.scored = true;
                            ball.flying = false;
                            ball.active = false;
                            resolveShot(false, 'Saved by the goalkeeper', '255,120,120');
                            return;
                        }
                        
                        // 只要足球越过红线，并且在此之前没有碰到守门员，就立即确认本球成功。
                        // 但先不结算，让球继续飞进球网内部，保持视觉表现完整。
                        if (ball.y <= goal.lineY) {
                            ball.goalConfirmed = true;
                            //$tip.text('GOAL! 已越过红线，足球继续飞入球网');
                        }
                    }
                    
                    // 飞到最终落点后再正式结算：
                    // 已越线则成功，否则算射偏。
                    if (t >= 1 && !ball.scored) {
                        ball.scored = true;
                        ball.flying = false;
                        ball.active = false;
                        
                        if (ball.goalConfirmed) {
                            resolveShot(true, 'GOAL!', '255,216,77');
                        } else {
                            resolveShot(false, 'Shot off target', '255,120,120');
                        }
                        return;
                    }
                }
                
                state.goalFlash = Math.max(0, state.goalFlash - dt * 2.2);
                state.resultTimer = Math.max(0, state.resultTimer - dt);
                
                state.particles = state.particles.filter((p) => {
                    p.age += dt;
                    p.x += p.vx * dt;
                    p.y += p.vy * dt;
                    p.vy += 185 * dt;
                    return p.age < p.life;
                });
            }
            
            // 处理本球结果：进球 / 扑救 / 射偏
            resolveShot = function(success, text, particleColor = '255,216,77') {
                if (state.shotResolved) return;
                state.shotResolved = true;

                const currentShot = 8 - state.shotsLeft;
                let gained = 0;
                if (success) {
                    // step
                    that.scoreLog(1,currentShot)
                    // 进球成功
                    state.goalCount++;
                    const inTarget =
                    ball.targetX >= targetZone.x &&
                    ball.targetX <= targetZone.x + targetZone.w &&
                    ball.targetY >= targetZone.y &&
                    ball.targetY <= targetZone.y + targetZone.h;
                    
                    // 死角判定：根据球穿过球门线的位置（lineCrossX）
                    const cornerBonus = (
                    ball.lineCrossX < goal.x + 42 ||
                    ball.lineCrossX > goal.x + goal.w - 42
                    );
                    
                    // 基础进球得分
                    gained = 10;
                    if (ball.power > 0.75) gained += 3;
                    if (inTarget) gained += 8;
                    if (cornerBonus) gained += 5;
                    
                    state.combo += 1;
                    if (state.combo >= 2) gained += Math.min(10, (state.combo - 1) * 2);
                    
                    state.score += gained;
                    state.goalFlash = 1;
                    createBurst(ball.x, ball.y, 20, particleColor);
                    $tip.text(`${text}`);
                    state.resultText = inTarget ? 'Perfect hit!' : (cornerBonus ? 'Top corner finish!' : 'Beautiful goal!');
                } else {
                    // step
                    that.scoreLog(0,currentShot)
                    state.combo = 0;
                    createBurst(ball.x, ball.y, 10, particleColor);
                    $tip.text(text);
                    state.resultText = text;
                }
                
                state.resultTimer = 1.5;
                state.shotsLeft -= 1;
                updateHud();
                
                ball.flying = false;
                ball.active = false;
                
                setTimeout(() => {
                    if (state.shotsLeft <= 0) {
                        finishGame();
                    } else {
                        randomizeRound();
                        resetBall();
                        $tip.text(`Preparing Ball ${8 - state.shotsLeft} | You have 15 seconds to complete it after dragging starts`);
                        updateHud();
                    }
                }, 1500);
            };
            
            finishGame = function() {
                state.running = false;
                // 历史总分 本局得分
                state.bestScore += state.score;
                // 结束游戏----------------------------------------------- 
                that.endGame()
                if(state.goalCount<3){
                    that.badgeIndex=0
                }else if(state.goalCount<6){
                    that.badgeIndex=1
                }else if(state.goalCount==6){
                    that.badgeIndex=2
                }else if(state.goalCount==7){
                    that.badgeIndex=3
                }
                that.goalNum = state.goalCount
                updateHud();
                $endTitle.text(state.score >= 90 ? 'Masterful performance!' : state.score >= 60 ? 'Very impressive!' : 'GAME OVER');
                //$endText.text(`This game's score is ${state.score} points, and the total score is ${state.bestScore} points`);
                that.gameMask = that.gamePopup = true
            };
            
            // 绘制草地背景、场地线、闪光效果
            function drawPitch() {
                ctx.clearRect(0, 0, W, H);
            
                if (grassImg.complete && grassImg.naturalWidth > 0) {
            
                    const imgW = grassImg.naturalWidth;
                    const imgH = grassImg.naturalHeight;
            
                    const scale = Math.max(
                        W / imgW,
                        H / imgH
                    );
            
                    const drawW = imgW * scale;
                    const drawH = imgH * scale;
            
                    const drawX = (W - drawW) / 2;
                    const drawY = (H - drawH) / 2;
            
                    ctx.drawImage(
                        grassImg,
                        drawX,
                        drawY,
                        drawW,
                        drawH
                    );
            
                } else {
                    ctx.fillStyle = '#2d8b43';
                    ctx.fillRect(0, 0, W, H);
                }
            
                // 原来的球场线
                ctx.strokeStyle = 'rgba(255,255,255,.35)';
                ctx.lineWidth = 2;
            
                ctx.beginPath();
                ctx.arc(
                    W / 2,
                    H * 0.68,
                    Math.min(90, W * 0.18),
                    0,
                    Math.PI,
                    true
                );
                ctx.stroke();
            
                ctx.beginPath();
                ctx.arc(W / 2, H * 0.68, 3, 0, Math.PI * 2);
                ctx.fillStyle = 'rgba(255,255,255,.7)';
                ctx.fill();
            }
            
            // 绘制球门与球网（进球判定线仅用于逻辑，不在画面中显示）
            function drawGoal() {
                ctx.save();
                
                ctx.fillStyle = '#efefef';
                ctx.fillRect(goal.x - 6, goal.y - 6, 6, goal.h + 18);
                ctx.fillRect(goal.x + goal.w, goal.y - 6, 6, goal.h + 18);
                ctx.fillRect(goal.x - 6, goal.y - 6, goal.w + 12, 6);
                
                ctx.fillStyle = 'rgba(220,235,255,.18)';
                ctx.fillRect(goal.x, goal.y, goal.w, goal.h);
                
                ctx.strokeStyle = 'rgba(255,255,255,.35)';
                ctx.lineWidth = 1;
                
                for (let i = 1; i < goal.netCols; i++) {
                    const x = goal.x + (goal.w / goal.netCols) * i;
                    ctx.beginPath();
                    ctx.moveTo(x, goal.y);
                    ctx.lineTo(x, goal.y + goal.h);
                    ctx.stroke();
                }
                
                for (let i = 1; i < goal.netRows; i++) {
                    const y = goal.y + (goal.h / goal.netRows) * i;
                    ctx.beginPath();
                    ctx.moveTo(goal.x, y);
                    ctx.lineTo(goal.x + goal.w, y);
                    ctx.stroke();
                }
                
                ctx.restore();
            }
            
            // 绘制守门员
            function drawKeeper() {
                const x = keeper.x;
                const y = keeper.y;
                const w = keeper.w;
                const h = keeper.h;
            
                ctx.save();
            
                // 身体（黑色）
                ctx.fillStyle = '#000000';
                roundRectPath(x, y + h * 0.25, w, h * 0.75, 12);
                ctx.fill();
            
                // 头部（红色）
                ctx.fillStyle = '#ff0000';
                ctx.beginPath();
                ctx.arc(
                    x + w * 0.5,
                    y + h * 0.18,
                    h * 0.26,
                    0,
                    Math.PI * 2
                );
                ctx.fill();
            
                ctx.lineWidth = 6;
                ctx.lineCap = 'round';
            
                // 手臂（红色）
                ctx.strokeStyle = '#ffffff';
                ctx.beginPath();
                ctx.moveTo(x + w * 0.18, y + h * 0.45);
                ctx.lineTo(x + w * 0.82, y + h * 0.45);
                ctx.stroke();
            
                // 腿（白色）
                ctx.strokeStyle = '#ff0000';
                ctx.beginPath();
            
                ctx.moveTo(x + w * 0.24, y + h * 0.95);
                ctx.lineTo(x + w * 0.4, y + h * 1.18);
            
                ctx.moveTo(x + w * 0.76, y + h * 0.95);
                ctx.lineTo(x + w * 0.6, y + h * 1.18);
            
                ctx.stroke();
            
                ctx.restore();
            }
            
            function roundRectPath(x, y, width, height, radius) {
                ctx.beginPath();
                ctx.moveTo(x + radius, y);
                ctx.lineTo(x + width - radius, y);
                ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
                ctx.lineTo(x + width, y + height - radius);
                ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
                ctx.lineTo(x + radius, y + height);
                ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
                ctx.lineTo(x, y + radius);
                ctx.quadraticCurveTo(x, y, x + radius, y);
                ctx.closePath();
            }
            
            // 绘制足球与地面阴影
            function drawBall(x, y, r) {

                ctx.save();
            
                // 阴影
                ctx.fillStyle = 'rgba(0,0,0,.18)';
                ctx.beginPath();
                ctx.ellipse(
                    ball.startX,
                    ball.startY + r * 1.7,
                    r * 1.1 * (ball.shadowScale || 1),
                    r * 0.48 * (ball.shadowScale || 1),
                    0,
                    0,
                    Math.PI * 2
                );
                ctx.fill();
            
                // 足球图片
                if (ballImg.complete && ballImg.naturalWidth > 0) {
            
                    ctx.translate(x, y);
                    ctx.rotate(ball.rotation);

                    ctx.drawImage(
                        ballImg,
                        -r,
                        -r,
                        r * 2,
                        r * 2
                    );
            
                } else {
            
                    // 图片未加载时的备用圆
                    ctx.beginPath();
                    ctx.arc(x, y, r, 0, Math.PI * 2);
                    ctx.fillStyle = '#fff';
                    ctx.fill();
                }
            
                ctx.restore();
            }
            
            function polygon(cx, cy, radius, sides) {
                ctx.beginPath();
                for (let i = 0; i < sides; i++) {
                    const a = -Math.PI / 2 + (Math.PI * 2 * i) / sides;
                    const px = cx + Math.cos(a) * radius;
                    const py = cy + Math.sin(a) * radius;
                    if (i === 0) ctx.moveTo(px, py);
                    else ctx.lineTo(px, py);
                }
                ctx.closePath();
            }
            
            // 绘制白色虚线：作为“拉动蓄力”的反向提示线
            function drawAimGuide() {
                if (!state.dragging || !state.aimStart || !state.aimCurrent) return;
                const dx = state.aimCurrent.x - state.aimStart.x;
                const dy = state.aimCurrent.y - state.aimStart.y;
                const len = Math.min(Math.hypot(dx, dy), 160);
                
                ctx.save();
                ctx.setLineDash([8, 8]);
                ctx.strokeStyle = 'rgba(255,255,255,.82)';
                ctx.lineWidth = 3;
                ctx.beginPath();
                ctx.moveTo(ball.x, ball.y);
                ctx.lineTo(ball.x - dx * 0.55, ball.y - dy * 0.55);
                ctx.stroke();
                ctx.restore();
                
                const power = Math.round((len / 160) * 100);
                $tip.text(`Strength ${power}% | Release the shot`);
            }
            
            // 绘制粒子特效
            function drawParticles() {
                for (const p of state.particles) {
                    const alpha = 1 - p.age / p.life;
                    ctx.fillStyle = `rgba(${p.color},${alpha})`;
                    ctx.beginPath();
                    ctx.arc(p.x, p.y, p.size, 0, Math.PI * 2);
                    ctx.fill();
                }
            }
            
            // 在中间显示本球结果文案
            function drawResultText() {
                if (state.resultTimer <= 0) return;
                ctx.save();
                ctx.textAlign = 'center';
                ctx.font = window.innerWidth>750?'700 34px sans-serif':'700 24px sans-serif';
                ctx.fillStyle = `rgba(0,0,0,${Math.min(1, state.resultTimer + 0.1)})`;
                ctx.fillText(state.resultText, W / 2, H * 0.42);
                ctx.font = window.innerWidth>750?'600 18px sans-serif':'600 16px sans-serif';
                ctx.fillText(`Difficulty Lv.${state.level}`, W / 2, H * 0.47);
                ctx.restore();
            }
            
            // 每一帧统一渲染画面
            function render() {
                drawPitch();
                drawGoal();
                drawKeeper();
                drawParticles();
                
                if (ball.active || ball.flying) {
                    const scale = ball.flying ? (1 - 0.55 * Math.min(ball.t, 1)) : 1;
                    drawBall(ball.x, ball.y, ball.r * scale);
                }
                
                drawAimGuide();
                drawResultText();
            }
            
            // 主循环：requestAnimationFrame 驱动更新与渲染
            function loop(ts) {
                const dt = Math.min(0.033, (ts - state.lastTime) / 1000 || 0.016);
                state.lastTime = ts;
                update(dt);
                render();
                requestAnimationFrame(loop);
            }
            
            // 绑定按钮事件
            // 改为 jQuery 的 on() 写法，方便后续统一维护
            $startBtn.on('click', beginGame);
            $restartBtn.on('click', beginGame);
            
            // 鼠标事件
            $canvas.on('mousedown', handleDown);
            $canvas.on('mousemove', handleMove);
            $(window).on('mouseup', handleUp);
            
            // 触摸事件：仍然阻止默认行为，避免页面滚动干扰游戏操作
            $canvas.on('touchstart', (e) => { e.preventDefault(); handleDown(e.originalEvent); });
            $canvas.on('touchmove', (e) => { e.preventDefault(); handleMove(e.originalEvent); });
            $(window).on('touchend', () => { handleUp(); });
            
            // 窗口尺寸变化时，重新计算布局
            $(window).on('resize', resize);
            
            resize();
            updateHud();
            requestAnimationFrame(loop);
        }
    },
    created(){
        //提前加载图片
        const preloadImages = () => {
            for(let i=0;i<this.badgeImg.length;i++){
                var img = new Image();
                img.src = this.badgeImg[i];
            }
        };
        preloadImages()

        // 加载完成后 更新弹窗显示样式
        this.loadFlag = true

        if(this.getCookie('_OXVA_Cheers_to_good_times_')){
            this.isLogin = true
            this.user.token = this.getCookie('_OXVA_Cheers_to_good_times_')

            this.getInfo()
        }
        

        this.getCountry()
        this.getData()
    },
    mounted(){
        function showUp(dom){
            gsap.from(dom,{
                y:'2rem',opacity:0,ease:'none',duration:0.5,
                scrollTrigger:{
                    trigger:dom,
                    start:'top bottom-=20%',
                    end:'+=0',
                }
            })
        }
        
        var wFlag = window.innerWidth>750

        $('.box2_item2').click(function(){
            if(!wFlag){
                document.querySelector(".Mbox6").scrollIntoView({block: "start",behavior: "smooth"});
            }
        })

        //box1
        ScrollTrigger.create({
            trigger:'.box1',
            start:wFlag?'top top+=5%':'top top+=6%',
            end:'+=30%',
            scrub:1,
            animation:gsap.timeline()
                .from('.box1_bg img',{scale:0.5,opacity:0,stagger:{each: 0.1,from: "end"},ease:'none'})
                .from('.box1_icon1',{x:wFlag?'25rem':'8rem',y:wFlag?'8rem':'-5rem',scale:0.5})
                .from('.box1_icon2',{x:wFlag?'25rem':'-8rem',y:wFlag?'-10rem':'4rem',scale:0.5},'<')
                .from('.box1_icon3',{x:wFlag?'-21rem':'-4rem',y:wFlag?'14rem':'6rem',scale:0.5},'<')
        })
        ScrollTrigger.create({
            trigger:'.box1',
            start:wFlag?'top top+=5%':'top top+=6%',
            end:'+=50%',
            pin:true,
        })

        //box2
        gsap.registerPlugin(SplitText,ScrollTrigger)
        SplitText.create(".box2_title", {
            type: "chars", //words
            autoSplit: true,
            charsClass:"chars++",
            onSplit(self) {
                return gsap.from(self.chars, {
                    y: 20,
                    opacity: 0,
                    //duration: 0.7, 
                    ease: "power4",
                    stagger: 0.05,
                    scrollTrigger:{
                        trigger:'.box2',
                        start:'top bottom-=20%',
                        end:'+=0',
                        toggleActions:'play none none reverse',
                    }
                });
            }
        });

        if(wFlag){
            SplitText.create(".box6_title", {
                type: "chars",
                autoSplit: true,
                charsClass:"box6_chars++",
            });
            ScrollTrigger.create({
                trigger:'.box2',
                start:'top top+=25%',
                end:'+=0%',
                //toggleActions:'play none none reverse',
                animation:gsap.timeline()
                    .from('.box2_bg',{opacity:0})
                    .from('.box2Swiper .swiper-wrapper .swiper-slide:nth-child(1)',{x:'106%'})
                    .from('.box2Swiper .swiper-wrapper .swiper-slide:nth-child(3)',{x:'-106%'},'<')
            })

            
            ScrollTrigger.create({
                trigger:'.box2',
                start:'top+=10% top+=6%',
                end:'+=50%',
                scrub:1,
                onUpdate:(self)=>{
                    let index = Math.floor(self.progress * 10);
                    $('.box6_info').toggleClass('opacity0',index>0.5)
                },
                animation:gsap.timeline()
                    .from('.box6',{clipPath:'inset(20% 37% 20% 37% round 2rem)',y:'2%',scale:0.73})
                    .from('.box6_img',{opacity:0},'-=80%')
                    .from('.box6_title',{opacity:0})
                    .from('.box6_text',{opacity:0},'<')
                    .from('.box3_btn',{opacity:0},'<')
                    .from('.box3_rule',{opacity:0},'<')
            })
            
            ScrollTrigger.create({
                trigger:'.box2',
                start:'top top+=6%',
                end:'+=80%',
                pin:true,
            })
        }else{

            SplitText.create(".box6_title", {
                type: "chars",
                autoSplit: true,
                charsClass:"box6_chars++",
                onSplit(self) {
                    return gsap.from(self.chars, {
                        y: 20,
                        opacity: 0,
                        //duration: 0.7, 
                        ease: "power4",
                        stagger: 0.05,
                        scrollTrigger:{
                            trigger:'.Mbox6',
                            start:'top bottom-=20%',
                            end:'+=0',
                            toggleActions:'play none none reverse',
                        }
                    });
                }
            });

            var box2Swiper = new Swiper('.box2Swiper', {
                //autoplay: true,
                slidesPerView: 1.5,
                centeredSlides: true,
            })
            box2Swiper.slideTo(1, 1000, false);
        }
        gsap.from('.box3_btn span',{opacity:0,stagger:{each: 0.2,from: "end"},ease:'none',repeat: -1,yoyo: true})

        //box4
        if(!wFlag){
            showUp('.box4_title')
        }

        ScrollTrigger.create({
            trigger:'.box4',
            start:'top center-=20%',
            end:'+=0',
            animation:gsap.timeline()
                .from('.box4_text',{opacity:0,y:'6rem'})
        })

        if(wFlag){
            new Swiper('.box5Swiper1', {
                speed:12000,
                autoplay: {
                  delay: 0,
                  disableOnInteraction: false,
                  //waitForTransition: false,
                },
                slidesPerView:6,
                loop:true
            })
    
            new Swiper('.box5Swiper2', {
                speed:12000,
                autoplay: {
                  delay: 0,
                  disableOnInteraction: false,
                  reverseDirection: true
                  //waitForTransition: false,
                },
                slidesPerView:6,
                loop:true
            })
        }else{
            var box5Flag = true
            $('.box5_bottom div p').click(function(){
                if(box5Flag){
                    $(this).text('Show Less')
                    $('.box5_bottom img:nth-child(n+7)').show()
                }else{
                    $(this).text('View More')
                    $('.box5_bottom img:nth-child(n+7)').hide()
                }
                box5Flag = !box5Flag
            })
        }
    }
})